import type { LucideIcon } from "lucide-react";
import {
  BookText,
  Cat,
  ChartPie,
  Download,
  GitBranch,
  GitPullRequest,
  House,
  Settings,
  Shield,
} from "lucide-react";

import type { AppView } from "./types";

export type MenuSidebarSection = Extract<
  AppView,
  | "sessions"
  | "circuits"
  | "moriarty"
  | "github-reviews"
  | "docs"
  | "download"
  | "stats"
  | "preferences"
  | "admin"
>;

export interface AppMenuItemDefinition {
  key: MenuSidebarSection;
  label: string;
  icon: LucideIcon;
  queryParam:
    | "stats"
    | "circuits"
    | "moriarty"
    | "github-reviews"
    | "docs"
    | "download"
    | "preferences"
    | "admin"
    | null;
  requiresAdmin?: boolean;
  tone: "cyan" | "magenta";
}

export const APP_MENU_ITEMS: AppMenuItemDefinition[] = [
  {
    key: "sessions",
    label: "Sherlog",
    icon: House,
    queryParam: null,
    tone: "cyan",
  },
  {
    key: "circuits",
    label: "Circuits",
    icon: GitBranch,
    queryParam: "circuits",
    tone: "cyan",
  },
  {
    key: "moriarty",
    label: "Moriarty",
    icon: Cat,
    queryParam: "moriarty",
    tone: "magenta",
  },
  {
    key: "github-reviews",
    label: "PR Reviews",
    icon: GitPullRequest,
    queryParam: "github-reviews",
    tone: "cyan",
  },
  {
    key: "docs",
    label: "Docs",
    icon: BookText,
    queryParam: "docs",
    tone: "cyan",
  },
  {
    key: "download",
    label: "Download CLI",
    icon: Download,
    queryParam: "download",
    tone: "cyan",
  },
  {
    key: "stats",
    label: "Stats",
    icon: ChartPie,
    queryParam: "stats",
    tone: "cyan",
  },
  {
    key: "preferences",
    label: "Settings",
    icon: Settings,
    queryParam: "preferences",
    tone: "cyan",
  },
  {
    key: "admin",
    label: "Admin",
    icon: Shield,
    queryParam: "admin",
    requiresAdmin: true,
    tone: "cyan",
  },
];

export function getPagesMenuItems<T extends AppMenuItemDefinition>(items: T[]): T[] {
  return items.filter((item) => item.key !== "sessions");
}

export function resolveMenuSectionFromView(view: AppView): MenuSidebarSection | null {
  switch (view) {
    case "sessions":
      return "sessions";
    case "circuits":
      return "circuits";
    case "moriarty":
    case "moriarty-detail":
    case "moriarty-config":
    case "moriarty-costs":
      return "moriarty";
    case "github-reviews":
    case "github-reviews-codex":
    case "github-reviews-codex-rule":
      return "github-reviews";
    case "docs":
      return "docs";
    case "download":
      return "download";
    case "stats":
      return "stats";
    case "preferences":
      return "preferences";
    case "admin":
      return "admin";
    default:
      return null;
  }
}

export function isMenuSidebarView(view: AppView): boolean {
  const section = resolveMenuSectionFromView(view);
  return section !== null && section !== "sessions";
}
